"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[302],{

/***/ 8302:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ shop; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(7812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/text-clipper/dist/index.js
var dist = __webpack_require__(5104);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./utils/classnames.ts
function classnames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.filter(Boolean).join(' ');
}

/* harmony default export */ var utils_classnames = (classnames);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Image/Image.tsx
/* eslint-disable react/jsx-props-no-spreading */




function Image(props) {
  var _useState = (0,react.useState)(true),
      isLoading = _useState[0],
      setLoading = _useState[1];

  var _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      src = props.src,
      alt = props.alt,
      sizes = props.sizes,
      width = props.width,
      height = props.height,
      _props$objectFit = props.objectFit,
      objectFit = _props$objectFit === void 0 ? 'cover' : _props$objectFit,
      _props$layout = props.layout,
      layout = _props$layout === void 0 ? 'fill' : _props$layout;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "".concat(className && className, "\n    w-full\n    overflow-hidden").trim(),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
      layout: layout,
      src: src,
      alt: alt,
      width: width,
      height: height,
      sizes: sizes,
      objectFit: objectFit,
      className: utils_classnames('group-hover:opacity-75 duration-700 ease-in-out', isLoading ? 'grayscale blur-2xl scale-110' : 'grayscale-0 blur-0 scale-100'),
      onLoadingComplete: function onLoadingComplete() {
        return setLoading(false);
      }
    })
  });
}
/* harmony default export */ var Image_Image = ((/* unused pure expression or super */ null && (Image)));
;// CONCATENATED MODULE: ./components/Image/index.ts

// EXTERNAL MODULE: ./components/Link/index.ts + 1 modules
var Link = __webpack_require__(4545);
;// CONCATENATED MODULE: ./components/ProductCard/ProductCard.tsx





function ProductCard(_ref) {
  var _product$image, _product$image2, _product$image3;

  var product = _ref.product;
  var description = (0,dist/* default */.Z)(product === null || product === void 0 ? void 0 : product.shortDescription, 60, {
    html: true,
    maxLines: 2,
    breakWords: true
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Link/* Link */.r, {
    className: "product-card max-w-[16rem] md:max-w-none min-w-[16rem] no-underline text-inherit flex flex-col min-h-full justify-start items-center relative rounded overflow-hidden hover:shadow-lg bg-cornsilk-300 transition-shadow duration-500",
    id: product.slug,
    href: "/shop/".concat(product.slug),
    children: [(product === null || product === void 0 ? void 0 : product.image) && /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
      className: "bg-gray-200 h-full min-h-[16rem] relative aspect-w-1 aspect-h-1 xl:aspect-w-7 xl:aspect-h-8 mb-3",
      src: (_product$image = product.image) === null || _product$image === void 0 ? void 0 : _product$image.thumbnailUrl,
      alt: (_product$image2 = product.image) === null || _product$image2 === void 0 ? void 0 : _product$image2.altText,
      sizes: (_product$image3 = product.image) === null || _product$image3 === void 0 ? void 0 : _product$image3.sizes
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "product-card-content w-full max-h-[10rem] h-64 px-6 py-4 flex flex-col justify-between",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "title font-serif font-bold text-xl mb-0",
        children: product === null || product === void 0 ? void 0 : product.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "description font-sans text-sm",
        dangerouslySetInnerHTML: {
          __html: description
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "price mt-auto justify-self-end font-sans font-semibold text-lg",
        children: product === null || product === void 0 ? void 0 : product.price
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./components/ProductCard/index.ts

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js + 3 modules
var react_final_form_es = __webpack_require__(5249);
// EXTERNAL MODULE: ./hooks/mobile.ts + 12 modules
var mobile = __webpack_require__(567);
// EXTERNAL MODULE: ./components/AnimationProvider/index.ts + 2 modules
var AnimationProvider = __webpack_require__(5751);
;// CONCATENATED MODULE: ./components/ProductCardGridFilters/ProductCardGridFilters.tsx





var _excluded = ["sortBy"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










function FilterFormButtons(_ref) {
  var updateFilters = _ref.updateFilters;

  var _useForm = (0,react_final_form_es/* useForm */.cI)(),
      reset = _useForm.reset;

  var clearFilters = function clearFilters() {
    reset();
    updateFilters({
      sortBy: 'MENU_ORDER',
      tags: []
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "drawer-footer",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      type: "button",
      className: "secondary-button w-1/2",
      onClick: clearFilters,
      children: "Clear"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      type: "submit",
      className: "primary-button w-1/2 ",
      children: "Search"
    })]
  });
}

function MobileWrapper(props) {
  var _children = props.children,
      onSubmit = props.onSubmit,
      initialValues = props.initialValues,
      className = props.className;

  var _useState = (0,react.useState)(false),
      showingModal = _useState[0],
      toggleModal = _useState[1];

  var _useAnimation = (0,AnimationProvider/* useAnimation */._7)(),
      anime = _useAnimation.anime;

  (0,react.useEffect)(function () {
    anime({
      targets: '.filters-button',
      translateY: [200, 0],
      opacity: [0, 1],
      duration: 300,
      delay: 500,
      easing: 'easeInOutSine'
    });
  }, []);

  var submitAndClose = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values) {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onSubmit(values);

            case 2:
              toggleModal(false);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function submitAndClose(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  (0,react.useEffect)(function () {
    anime({
      targets: '.filters-drawer',
      translateY: [300, 0],
      opacity: [0, 1],
      duration: 300,
      delay: 100,
      easing: 'easeInOutSine'
    });
    anime({
      targets: '.filters-drawer-overlay',
      opacity: [0, 0.8],
      duration: 500,
      easing: 'easeInOutSine'
    });
  }, [showingModal]);

  var closeModal = function closeModal() {
    anime({
      targets: '.filters-drawer',
      translateY: [0, 300],
      opacity: [1, 0],
      duration: 300,
      easing: 'easeInOutSine',
      complete: function complete() {
        return toggleModal(false);
      }
    });
    anime({
      targets: '.filters-drawer-overlay',
      opacity: [0.8, 0],
      duration: 300,
      easing: 'easeInOutSine'
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("button", {
      type: "button",
      className: "filters-button icon-button primary-button w-2/5 fixed inset-x-0 mx-auto bottom-10 z-30",
      onClick: function onClick() {
        return toggleModal(true);
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("i", {
        className: "fa-solid fa-filter mr-1"
      }), "Sort & Filter"]
    }), showingModal && /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
      onSubmit: submitAndClose,
      initialValues: initialValues,
      children: function children(_ref3) {
        var handleSubmit = _ref3.handleSubmit;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
          className: className,
          onSubmit: handleSubmit,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "filters-drawer-overlay drawer-overlay",
            onClick: function onClick() {
              return toggleModal(false);
            },
            onKeyPress: function onKeyPress() {
              return toggleModal(false);
            },
            role: "button",
            "aria-label": "overlay",
            tabIndex: -1
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "filters-drawer drawer left-0 bottom-0 w-full",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "drawer-content",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
                type: "button",
                className: "drawer-close-button",
                onClick: closeModal,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
                  className: "fa-solid fa-xmark"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "drawer-header",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("i", {
                  className: "fa-solid fa-filter mr-1"
                }), "Filters"]
              }), _children]
            })
          })]
        });
      }
    })]
  });
}

function DesktopWrapper(props) {
  var _children2 = props.children,
      onSubmit = props.onSubmit,
      initialValues = props.initialValues,
      className = props.className;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat(className, " shop-page-section w-2/6 p-0 md:pb-0").trim(),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: "shop-page-section-header bg-transparent",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("i", {
        className: "fa-solid fa-filter mr-1"
      }), "Filters"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es/* Form */.l0, {
      onSubmit: onSubmit,
      initialValues: initialValues,
      children: function children(_ref4) {
        var handleSubmit = _ref4.handleSubmit;
        return /*#__PURE__*/(0,jsx_runtime.jsx)("form", {
          onSubmit: handleSubmit,
          className: "w-full h-full flex flex-col",
          children: _children2
        });
      }
    })]
  });
}

function ProductCardGridFilters(props) {
  var allTags = props.allTags,
      updateFilters = props.updateFilters,
      filters = props.filters;
  var isTabletOrMobile = (0,mobile/* useIsTabletOrMobile */.I)();
  var Wrapper = isTabletOrMobile ? MobileWrapper : DesktopWrapper;

  var _useAnimation2 = (0,AnimationProvider/* useAnimation */._7)(),
      newTimeline = _useAnimation2.newTimeline,
      add = _useAnimation2.add,
      anime = _useAnimation2.anime;

  (0,react.useEffect)(function () {
    newTimeline('product-card-grid-filters', {
      direction: 'normal',
      autoplay: true,
      easing: 'easeInOutSine'
    });

    (0,toConsumableArray/* default */.Z)(Array(4)).forEach(function (_, index) {
      add('product-card-grid-filters', {
        targets: ".product-card-grid-filters .radio-button-wrapper:nth-of-type(".concat(Number(index) + 1, ")"),
        opacity: [0, 1],
        duration: 150,
        delay: anime.stagger(50)
      });
    });

    (0,toConsumableArray/* default */.Z)(Array(allTags.length + 1)).forEach(function (_, index) {
      add('product-card-grid-filters', {
        targets: ".product-card-grid-filters .checkbox-wrapper:nth-of-type(".concat(Number(index) + 1, ")"),
        opacity: [0, 1],
        duration: 150,
        delay: anime.stagger(50, {
          start: 150
        })
      });
    });

    add('product-card-grid-filters', {
      targets: '.product-card-grid-filters .drawer-footer',
      translateY: [200, 0],
      duration: 300,
      delay: 150
    });
  }, []);

  var onSubmit = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(values) {
      var sortBy, tags;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              sortBy = values.sortBy, tags = (0,objectWithoutProperties/* default */.Z)(values, _excluded);
              updateFilters({
                sortBy: sortBy,
                tags: Object.entries(tags).filter(function (_ref6) {
                  var _ref7 = (0,slicedToArray/* default */.Z)(_ref6, 2),
                      isTrue = _ref7[1];

                  return isTrue;
                }).map(function (_ref8) {
                  var _ref9 = (0,slicedToArray/* default */.Z)(_ref8, 1),
                      tag = _ref9[0];

                  return tag;
                })
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  var initialValues = _objectSpread({
    sortBy: filters.sortBy
  }, filters.tags.reduce(function (results, nextTag) {
    return _objectSpread(_objectSpread({}, results), {}, (0,defineProperty/* default */.Z)({}, nextTag, true));
  }, {}));

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    className: "product-card-grid-filters",
    onSubmit: onSubmit,
    initialValues: initialValues,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "drawer-subheader md:rounded-t-xl",
        children: "Sort By"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "radio-button-wrapper mr-4 mb-4 px-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          className: "radio-button-label",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
            component: "input",
            type: "radio",
            name: "sortBy",
            value: "LOW_TO_HIGH",
            className: "hidden"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "radio-button"
          }), "Low to High"]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "radio-button-wrapper mr-4 mb-4 px-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          className: "radio-button-label",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
            component: "input",
            type: "radio",
            name: "sortBy",
            value: "HIGH_TO_LOW",
            className: "hidden"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "radio-button"
          }), "High to Low"]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "radio-button-wrapper mr-4 px-5",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
          className: "radio-button-label",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
            component: "input",
            type: "radio",
            name: "sortBy",
            value: "MENU_ORDER",
            className: "hidden"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "radio-button"
          }), "Most Popular"]
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "drawer-subheader mt-2",
        children: "Tags"
      }), allTags.map(function (_ref10) {
        var id = _ref10.id,
            name = _ref10.name,
            slug = _ref10.slug;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "checkbox-wrapper mb-4 px-5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_final_form_es/* Field */.gN, {
            component: "input",
            type: "checkbox",
            name: slug,
            id: slug,
            "aria-describedby": slug,
            className: "checkbox"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("label", {
            htmlFor: slug,
            className: "checkbox-label",
            children: name
          })]
        }, id);
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(FilterFormButtons, {
      updateFilters: updateFilters
    })]
  });
}
;// CONCATENATED MODULE: ./components/ProductCardGridFilters/index.ts

;// CONCATENATED MODULE: ./hooks/useProductFilters.ts



/**
 *
 * Utility function to finds if a term is in a list of strings.
 *
 * @param base List of strings to search in.
 * @param term Term to search for.
 *
 * @returns true if term is in any of the strings in base, false otherwise.
 *
 */
var termIsInAny = function termIsInAny(base, term) {
  return base.reduce(function (accumulatedResult, currentValue) {
    return accumulatedResult || !!currentValue.toLowerCase().includes(term.toLowerCase());
  }, false);
};

var doesProductMatch = function doesProductMatch(searchText, category, tags) {
  return function (product) {
    var name = product.name,
        description = product.description,
        shortDescription = product.shortDescription,
        productCategories = product.productCategories,
        productTags = product.productTags;
    var categoryFound = false;

    if (category) {
      var _productCategories$no;

      productCategories === null || productCategories === void 0 ? void 0 : (_productCategories$no = productCategories.nodes) === null || _productCategories$no === void 0 ? void 0 : _productCategories$no.forEach(function (productCategory) {
        if ((productCategory === null || productCategory === void 0 ? void 0 : productCategory.slug) === category) {
          categoryFound = true;
        }
      });
    }

    if (category && !categoryFound) return false;
    var tagsFound = false;

    if (tags !== null && tags !== void 0 && tags.length) {
      var _productTags$nodes;

      productTags === null || productTags === void 0 ? void 0 : (_productTags$nodes = productTags.nodes) === null || _productTags$nodes === void 0 ? void 0 : _productTags$nodes.forEach(function (productTag) {
        if (tags.includes(productTag === null || productTag === void 0 ? void 0 : productTag.slug)) {
          tagsFound = true;
        }
      });
    }

    if (tags !== null && tags !== void 0 && tags.length && !tagsFound) {
      return false;
    } // Search in name, description, shortDescription


    var searchItems = [name, description, shortDescription].flatMap(function (x) {
      return x ? [x] : [];
    });

    if (searchItems.length > 0) {
      return termIsInAny(searchItems, searchText);
    }

    return false;
  };
};

var floatParser = function floatParser(_float) {
  return parseFloat(_float);
};

var compareProducts = function compareProducts(sortBy) {
  return function (productA, productB) {
    var priceA;
    var priceB;

    switch (sortBy) {
      case 'LOW_TO_HIGH':
        priceA = productA.type === 'VARIABLE' ? Math.min.apply(Math, (0,toConsumableArray/* default */.Z)(productA.rawPrice.split(', ').map(floatParser))) : floatParser(productA.rawPrice);
        priceB = productB.type === 'VARIABLE' ? Math.min.apply(Math, (0,toConsumableArray/* default */.Z)(productB.rawPrice.split(', ').map(floatParser))) : floatParser(productB.rawPrice);

        if (priceA > priceB) {
          return 1;
        }

        if (priceA < priceB) {
          return -1;
        }

        return 0;

      case 'HIGH_TO_LOW':
        priceA = productA.type === 'VARIABLE' ? Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(productA.rawPrice.split(', ').map(floatParser))) : floatParser(productA.rawPrice);
        priceB = productB.type === 'VARIABLE' ? Math.max.apply(Math, (0,toConsumableArray/* default */.Z)(productB.rawPrice.split(', ').map(floatParser))) : floatParser(productB.rawPrice);

        if (priceA > priceB) {
          return -1;
        }

        if (priceA < priceB) {
          return 1;
        }

        return 0;

      case 'MENU_ORDER':
      default:
        {
          var menuOrderA = productA.menuOrder || 0;
          var menuOrderB = productB.menuOrder || 0;

          if (menuOrderA > menuOrderB) {
            return 1;
          }

          if (menuOrderA < menuOrderB) {
            return -1;
          }

          return 0;
        }
    }
  };
};

function filterProducts(products, searchText, category, tags) {
  return products.filter(doesProductMatch(searchText, category, tags));
}
function sortProducts(products, sortBy) {
  products.sort(compareProducts(sortBy));
  return products;
}
function useProductFilters(products, filters, dependencies) {
  var searchText = filters.searchText,
      category = filters.category,
      tags = filters.tags,
      sortBy = filters.sortBy;

  var _useState = (0,react.useState)(filterProducts(sortProducts(products, sortBy), searchText.toLowerCase(), category, tags)),
      items = _useState[0],
      setItems = _useState[1];

  (0,react.useEffect)(function () {
    setItems(filterProducts(sortProducts(products, sortBy), searchText.toLowerCase(), category, tags));
  }, dependencies);
  return items;
}
;// CONCATENATED MODULE: ./components/ProductCardGrid/ProductCardGrid.tsx










// Converts sortby query param to sortBy filter
function getSortBy(slug) {
  switch (slug) {
    case 'low_to_high':
      return 'LOW_TO_HIGH';

    case 'high_to_low':
      return 'HIGH_TO_LOW';

    case 'menu_order':
    default:
      return 'MENU_ORDER';
  }
} // Converts tags query param to tags filter.


function getTags(tagSlugs) {
  var tags = [];

  if (tagSlugs) {
    tags.push.apply(tags, (0,toConsumableArray/* default */.Z)(tagSlugs.split(',')));
  }

  return tags;
}

function ProductCardGrid(_ref) {
  var products = _ref.products,
      allTags = _ref.tags;

  var _useAnimation = (0,AnimationProvider/* useAnimation */._7)(),
      newTimeline = _useAnimation.newTimeline,
      add = _useAnimation.add,
      anime = _useAnimation.anime;

  var _useRouter = (0,router.useRouter)(),
      query = _useRouter.query,
      push = _useRouter.push,
      activePath = _useRouter.asPath; // Selected product.


  var selected = (query === null || query === void 0 ? void 0 : query.slug) || undefined; // Text search state.

  var _useState = (0,react.useState)((query === null || query === void 0 ? void 0 : query.search) || ''),
      searchText = _useState[0],
      setSearchText = _useState[1];

  var _useState2 = (0,react.useState)(searchText),
      debouncedSearchText = _useState2[0],
      setDebouncedSearchText = _useState2[1]; // Filter state.


  var _useState3 = (0,react.useState)({
    sortBy: getSortBy(query === null || query === void 0 ? void 0 : query.sortby),
    tags: getTags(query === null || query === void 0 ? void 0 : query.tags)
  }),
      filtersState = _useState3[0],
      updateFilters = _useState3[1]; // Updates browser path if filters change.


  var maybeUpdatePath = function maybeUpdatePath() {
    return new Promise(function () {
      var nextPath = '/shop';
      var shallow = activePath.includes('/shop');

      if (selected) {
        nextPath = "/shop/".concat(selected);
      } // Add search text query param to path.


      var showSearchParam = !!searchText;
      nextPath += showSearchParam ? "?search=".concat(searchText) : ''; // Add sortby query param.

      var showSortByParam = filtersState.sortBy !== 'MENU_ORDER';

      if (showSortByParam) {
        nextPath += showSearchParam ? '&' : '?';
        nextPath += "sortby=".concat(filtersState.sortBy.toLowerCase());
      } // Add tags query param.


      var showTagsParam = filtersState.tags.length;

      if (showTagsParam) {
        nextPath += showSearchParam || showSortByParam ? '&' : '?';
        nextPath += "tags=".concat(filtersState.tags.join(','));
      }

      if (nextPath !== activePath) {
        push(nextPath, undefined, {
          shallow: shallow
        });
      }
    });
  }; // Processes search filters if any changes.


  var items = useProductFilters(products, {
    searchText: debouncedSearchText,
    tags: filtersState.tags,
    sortBy: filtersState.sortBy
  }, [products, debouncedSearchText, filtersState.tags, filtersState.sortBy]); // Update path if any changes.

  (0,react.useEffect)(function () {
    maybeUpdatePath();
  }, [products, debouncedSearchText, filtersState.tags, filtersState.sortBy]); // Update debouncedSearchText when searchText changes.

  (0,react.useEffect)(function () {
    var handler = setTimeout(function () {
      setDebouncedSearchText(searchText);
    }, 500);
    return function () {
      clearTimeout(handler);
    };
  }, [searchText]);
  (0,react.useEffect)(function () {
    newTimeline('product-card-grid-sections', {
      direction: 'normal',
      autoplay: true,
      easing: 'easeInOutSine'
    });

    (0,toConsumableArray/* default */.Z)(Array(4)).forEach(function (_, index) {
      add('product-card-grid-sections', {
        targets: ".shop-page-section:nth-of-type(".concat(Number(index), ")"),
        opacity: [0, 1],
        duration: 300,
        delay: anime.stagger(100)
      });
    });

    anime({
      targets: '.shop-page-section .form-field-input',
      opacity: [0, 1],
      duration: 300,
      delay: 400,
      easing: 'easeInOutSine'
    });
    newTimeline('product-card-grid-cards', {
      direction: 'normal',
      autoplay: true,
      easing: 'easeInOutSine'
    });
    items.forEach(function (_, index) {
      add('product-card-grid-cards', {
        targets: ".product-card:nth-child(".concat(Number(index) + 1, ")"),
        translateY: [300, 0],
        opacity: [0, 1],
        duration: 300,
        delay: anime.stagger(10, {
          start: 500
        })
      });
    });
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "w-full flex flex-row flex-wrap gap-5 px-5 lg:mx-0",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "shop-page-section w-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "shop-page-section-header",
        children: "Search"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("input", {
        className: "form-field-input w-full",
        type: "text",
        value: searchText,
        onChange: function onChange(e) {
          return setSearchText(e.target.value);
        }
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCardGridFilters, {
      allTags: allTags,
      filters: filtersState,
      updateFilters: updateFilters
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "shop-page-section w-full items-center justify-items-center md:flex-1 shrink grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        className: "shop-page-section-header",
        children: "Results"
      }), items.map(function (product) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCard, {
          product: product
        }, product === null || product === void 0 ? void 0 : product.id);
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./components/ProductCardGrid/index.ts

// EXTERNAL MODULE: ./node_modules/react-image-gallery/build/image-gallery.js
var image_gallery = __webpack_require__(6982);
var image_gallery_default = /*#__PURE__*/__webpack_require__.n(image_gallery);
;// CONCATENATED MODULE: ./components/ProductGallery/ProductGallery.tsx






function GalleryItem(item) {
  var src = item.original,
      alt = item.originalAlt,
      originalHeight = item.originalHeight,
      originalWidth = item.originalWidth,
      sizes = item.sizes;
  var isFullscreen =  true && !window.screenTop && !window.screenY;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: utils_classnames('image-gallery-image w-full h-full relative flex justify-center', isFullscreen ? 'max-h-screen' : ''),
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
      className: utils_classnames('relative', !isFullscreen ? 'max-w-xs w-80 h-80 max-h-80' : 'w-full h-80 md:h-screen'),
      src: src,
      alt: alt,
      sizes: sizes,
      objectFit: "contain",
      width: "".concat(originalWidth),
      height: "".concat(originalHeight),
      layout: "fill"
    })
  });
}

var ProductGallery = /*#__PURE__*/(0,react.forwardRef)(function (props, ref) {
  var main = props.main,
      _props$images = props.images,
      images = _props$images === void 0 ? [] : _props$images,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className;
  var gallery = images.map(function (image) {
    var _image$mediaDetails, _image$mediaDetails2;

    return {
      original: image.sourceUrl,
      thumbnail: image.thumbnailUrl,
      originalWidth: (_image$mediaDetails = image.mediaDetails) === null || _image$mediaDetails === void 0 ? void 0 : _image$mediaDetails.width,
      originalHeight: (_image$mediaDetails2 = image.mediaDetails) === null || _image$mediaDetails2 === void 0 ? void 0 : _image$mediaDetails2.height,
      originalAlt: image.altText,
      thumbnailAlt: image.altText,
      srcSet: image.srcSet,
      sizes: image.sizes
    };
  });
  var startIndex = gallery.findIndex(function (_ref) {
    var original = _ref.original;
    return original === main.sourceUrl;
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "product-gallery",
    className: className,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_gallery_default()), {
      renderItem: GalleryItem,
      ref: ref,
      items: gallery,
      startIndex: startIndex,
      showBullets: true,
      showNav: false,
      showPlayButton: false
    })
  });
});
;// CONCATENATED MODULE: ./components/ProductGallery/index.ts

// EXTERNAL MODULE: ./graphql/index.ts + 19 modules
var graphql = __webpack_require__(4997);
// EXTERNAL MODULE: ./hooks/useCartMutations.ts
var useCartMutations = __webpack_require__(4007);
;// CONCATENATED MODULE: ./components/QuantitySelector/QuantitySelector.tsx


function QuantitySelector(props) {
  var className = props.className,
      value = props.value,
      onIncrement = props.onIncrement,
      onDecrement = props.onDecrement;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat(className && className, " relative").trim(),
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
      type: "number",
      className: "form-field-input appearance-none block px-6 py-2.5 text-center w-full",
      value: value
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "icon-button secondary-button border-none text-russian-green-200 absolute left-2.5 bottom-0.5 focus:outline-none focus:border-russian-green-400 hover:border-russian-green-400",
      onClick: onDecrement,
      onKeyPress: onDecrement,
      role: "button",
      tabIndex: 0,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
        className: "fa-solid fa-minus"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: "icon-button secondary-button border-none text-russian-green-200 absolute right-2.5 bottom-0.5 focus:outline-none focus:border-russian-green-400 hover:border-russian-green-400",
      onClick: onIncrement,
      onKeyPress: onIncrement,
      role: "button",
      tabIndex: 0,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
        className: "fa-solid fa-plus"
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/QuantitySelector/index.ts

;// CONCATENATED MODULE: ./components/BasketOptions/BasketOptions.tsx


function BasketOptions_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function BasketOptions_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? BasketOptions_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : BasketOptions_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







function BasketOptions(_ref) {
  var _variations;

  var product = _ref.product,
      onVariationChange = _ref.onVariationChange,
      sticky = _ref.sticky;
  var formClassName = (0,react.useMemo)(function () {
    return "w-full\n    flex\n    flex-wrap \n    gap-y-5 \n    items-center \n    justify-between\n    order-5\n    md:justify-start\n    md:mt-auto\n    ".concat(sticky && 'sticky bottom-0 p-5 bg-champagne-300 border-t-2 border-cornsilk-300', "\n    ");
  }, [sticky]);
  var _ref2 = product,
      type = _ref2.type,
      soldIndividually = _ref2.soldIndividually,
      attributes = _ref2.attributes;
  var variations = ((_variations = product.variations) === null || _variations === void 0 ? void 0 : _variations.nodes) || [];

  var _useState = (0,react.useState)(((attributes === null || attributes === void 0 ? void 0 : attributes.nodes) || []).reduce(function (results, attribute) {
    var _ref3 = attribute,
        name = _ref3.name,
        options = _ref3.options,
        terms = _ref3.terms;
    return BasketOptions_objectSpread(BasketOptions_objectSpread({}, results), {}, (0,defineProperty/* default */.Z)({}, name, !terms ? options[0] : (terms === null || terms === void 0 ? void 0 : terms.nodes)[0].name));
  }, {})),
      selectedAttributes = _useState[0],
      selectAttributes = _useState[1];

  var selectedVariation = variations && variations.find(function (_ref4) {
    var _ref5;

    var variationAttributes = _ref4.attributes;
    return (_ref5 = (variationAttributes === null || variationAttributes === void 0 ? void 0 : variationAttributes.nodes) || []) === null || _ref5 === void 0 ? void 0 : _ref5.every(function (_ref6) {
      var value = _ref6.value,
          label = _ref6.label;
      return selectedAttributes[label] === value;
    });
  });

  var _useCartMutations = (0,useCartMutations/* default */.Z)(product.databaseId, selectedVariation === null || selectedVariation === void 0 ? void 0 : selectedVariation.databaseId),
      quantityFound = _useCartMutations.quantityFound,
      mutate = _useCartMutations.mutate;

  var _useState2 = (0,react.useState)(quantityFound ? 'update' : 'add'),
      mutation = _useState2[0],
      setMutation = _useState2[1];

  var _useState3 = (0,react.useState)(quantityFound || 1),
      quantity = _useState3[0],
      setQuantity = _useState3[1];

  (0,react.useEffect)(function () {
    setMutation(quantityFound ? 'update' : 'add');
    setQuantity(quantityFound || 1);
  }, [quantityFound]);
  var selectedProduct = selectedVariation || product;
  var outOfStock = selectedProduct.stockStatus === graphql/* StockStatusEnum.OutOfStock */.zN.OutOfStock;
  var submitButtonText = mutation === 'update' ? 'Update' : 'Add To Basket';

  if (outOfStock) {
    submitButtonText = 'Out of Stock';
  }

  var incrementQuantity = function incrementQuantity() {
    if (selectedProduct.stockStatus === graphql/* StockStatusEnum.InStock */.zN.InStock && !!selectedProduct.stockQuantity && selectedProduct.stockQuantity === quantity) {
      return;
    }

    setQuantity(quantity + 1);
  };

  var decrementQuantity = function decrementQuantity() {
    if (quantity === 1) {
      return;
    }

    setQuantity(quantity - 1);
  };

  (0,react.useEffect)(function () {
    if (selectedVariation) {
      onVariationChange && onVariationChange(selectedVariation);
    }
  }, [selectedVariation]);
  (0,react.useEffect)(function () {
    setMutation(quantityFound ? 'update' : 'add');
    setQuantity(quantityFound || 1);
  }, [quantityFound, selectedProduct]);

  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    mutate({
      mutation: mutation,
      quantity: quantity
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
    onSubmit: onSubmit,
    className: formClassName,
    children: [type === graphql/* ProductTypesEnum.Variable */.pS.Variable && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "w-full",
      children: ((attributes === null || attributes === void 0 ? void 0 : attributes.nodes) || []).map(function (attribute) {
        var _ref8;

        var _ref7 = attribute,
            id = _ref7.id,
            name = _ref7.name,
            label = _ref7.label,
            options = _ref7.options,
            isVariationAttribute = _ref7.variation,
            terms = _ref7.terms;

        if (!isVariationAttribute) {
          return null;
        }

        return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex flex-wrap justify-start gap-x-5 mb-5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "text-lg font-bold italic w-full flex-none",
            children: label
          }), (_ref8 = (terms === null || terms === void 0 ? void 0 : terms.nodes) || options) === null || _ref8 === void 0 ? void 0 : _ref8.map(function (option) {
            var value;
            var buttonLabel;

            if (typeof option !== 'object') {
              value = option;
              buttonLabel = option.replace('-', ' ').replace(/^\w/, function (c) {
                return c.toUpperCase();
              });
            } else {
              var _ref9 = option,
                  termName = _ref9.name,
                  slug = _ref9.slug;
              value = termName;
              buttonLabel = termName;
            }

            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "radio-button-wrapper shrink",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)("label", {
                className: "radio-button-label",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", {
                  type: "radio",
                  name: name,
                  value: value,
                  className: "hidden",
                  checked: selectedAttributes[name] === value,
                  onChange: function onChange() {
                    selectAttributes(BasketOptions_objectSpread(BasketOptions_objectSpread({}, selectedAttributes), {}, (0,defineProperty/* default */.Z)({}, name, value)));
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "radio-button"
                }), buttonLabel]
              })
            });
          })]
        }, id);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
      className: " inline-block font-sans font-semibold text-xl text-center w-2/12",
      children: ["$", parseFloat(selectedProduct.price.split('$')[1]) * quantity]
    }), !soldIndividually && /*#__PURE__*/(0,jsx_runtime.jsx)(QuantitySelector, {
      className: "w-9/12 ml-auto",
      value: quantity,
      onIncrement: incrementQuantity,
      onDecrement: decrementQuantity
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      type: "submit",
      className: "primary-button\n        disabled:bg-gray-500\n        ".concat(quantityFound ? 'w-9/12' : 'w-full', "\n        ").trim(),
      disabled: outOfStock,
      children: submitButtonText
    }), !!quantityFound && /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
      type: "submit",
      className: "icon-button primary-button h-11 bg-red-600 text-white hover:bg-red-400 w-2/12 ml-auto",
      onClick: function onClick() {
        return quantityFound && setMutation('remove');
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
        className: "fa-solid fa-trash-can"
      })
    })]
  });
}
;// CONCATENATED MODULE: ./components/BasketOptions/index.ts

;// CONCATENATED MODULE: ./components/ProductModal/ProductModal.tsx










function ProductModal(_ref) {
  var _product$galleryImage;

  var product = _ref.product;
  var galleryRef = (0,react.useRef)();
  var isTabletOrMobile = (0,mobile/* useIsTabletOrMobile */.I)();

  var _useRouter = (0,router.useRouter)(),
      push = _useRouter.push;

  var _useAnimation = (0,AnimationProvider/* useAnimation */._7)(),
      anime = _useAnimation.anime;

  (0,react.useEffect)(function () {
    anime({
      targets: '.product-modal',
      translateY: isTabletOrMobile ? [300, 0] : [300, '-50%'],
      translateX: isTabletOrMobile ? [0, 0] : ['-50%', '-50%'],
      opacity: [0, 1],
      duration: 300,
      delay: 100,
      easing: 'easeInOutSine'
    });
    anime({
      targets: '.product-modal-overlay',
      opacity: [0, 0.8],
      duration: 500,
      easing: 'easeInOutSine'
    });
  }, [isTabletOrMobile]);

  var backToShop = function backToShop() {
    anime({
      targets: '.product-modal',
      translateY: isTabletOrMobile ? [0, 300] : ['-50%', 300],
      translateX: isTabletOrMobile ? [0, 0] : ['-50%', '-50%'],
      opacity: [1, 0],
      duration: 300,
      easing: 'easeInOutSine',
      complete: function complete() {
        return push('/shop', undefined, {
          shallow: true
        });
      }
    });
    anime({
      targets: '.product-modal-overlay',
      opacity: [0.8, 0],
      duration: 300,
      easing: 'easeInOutSine'
    });
  };

  var handleVariationChange = function handleVariationChange(variation) {
    if (galleryRef.current) {
      var gallery = (0,toConsumableArray/* default */.Z)(galleryRef.current.props.items);

      var nextIndex = gallery.findIndex(function (_ref2) {
        var _variation$image;

        var original = _ref2.original;
        return original === ((_variation$image = variation.image) === null || _variation$image === void 0 ? void 0 : _variation$image.sourceUrl);
      });
      galleryRef.current.slideToIndex(nextIndex);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [!isTabletOrMobile && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "product-modal-overlay drawer-overlay top-20 z-40",
      onClick: backToShop,
      onKeyPress: backToShop,
      role: "button",
      tabIndex: -1,
      "aria-label": "overlay"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "product-modal drawer inset-0 w-full z-40 top-20 h-full-20 md:rounded-xl md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-11/12 lg:w-4/5 md:h-4/5 ",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex flex-wrap content-start min-h-full md:h-auto gap-5 px-10 pt-10 relative",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          type: "button",
          className: "drawer-close-button z-40",
          onClick: backToShop,
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("i", {
            className: "fa-solid fa-xmark"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "shop-page-section w-full md:w-1/2",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "shop-page-section-header",
            children: "Gallery"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductGallery, {
            ref: galleryRef,
            className: "w-full",
            main: product.image,
            images: (product === null || product === void 0 ? void 0 : (_product$galleryImage = product.galleryImages) === null || _product$galleryImage === void 0 ? void 0 : _product$galleryImage.nodes) || []
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "shop-page-section w-full flex-1 shrink",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "h-full w-full text-center flex flex-col order-5 md:order-2 md:text-left",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "font-serif font-bold text-2xl mb-0",
              children: product === null || product === void 0 ? void 0 : product.name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "product-modal-description font-sans text-lg",
              dangerouslySetInnerHTML: {
                __html: product === null || product === void 0 ? void 0 : product.shortDescription
              }
            }), !isTabletOrMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(BasketOptions, {
              product: product,
              onVariationChange: handleVariationChange
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "shop-page-section w-full text-center order-7 md:order-6 md:text-left mb-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "shop-page-section-header",
            children: "Description"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "product-modal-description font-sans text-base",
            dangerouslySetInnerHTML: {
              __html: product === null || product === void 0 ? void 0 : product.description
            }
          })]
        })]
      }), isTabletOrMobile && /*#__PURE__*/(0,jsx_runtime.jsx)(BasketOptions, {
        product: product,
        onVariationChange: handleVariationChange,
        sticky: true
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./components/ProductModal/index.ts

;// CONCATENATED MODULE: ./pages/shop/index.tsx






function Shop(_ref) {
  var products = _ref.products,
      tags = _ref.tags,
      product = _ref.product;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
    className: "container mx-auto py-5",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Honey Mart | Shop"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Apparel + Gifts"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "icon",
        href: "/favicon.ico"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProductCardGrid, {
      products: products,
      tags: tags
    }), product && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductModal, {
      product: product
    })]
  });
}

var __N_SSG = true;
/* harmony default export */ var shop = (Shop);

/***/ })

}]);